// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mzpIC","fullView":"styles_fullView__1OWzL"};